<template>
  <v-card>
    <v-card-title>
      <span class="headline">{{ formTitle }}</span>
    </v-card-title>
    <v-card-text>
      <v-container grid-list-md fluid wrap>
        <v-layout wrap>
          <v-flex xs12 sm3>
            <date-picker
              :gt-date-string="price.dateFrom"
              @onDateSelected="onDateFromSelected($event)"
              customLabel="Date From"
            ></date-picker>
          </v-flex>
          <v-flex xs12 sm3>
            <date-picker
              :gt-date-string="price.dateTo"
              @onDateSelected="onDateToSelected($event)"
              customLabel="Date to"
            ></date-picker>
          </v-flex>
          <v-flex xs12 sm3>
            <v-text-field
              label="Cost"
              v-model.number="price.adultBuy1"
              type="number"
            ></v-text-field>
          </v-flex>
          <v-flex xs12 sm3>
            <currency-list-select
              customLabel="Currency Buy"
              :currency-code="price.currencyCodeBuy"
              v-model="price.currencyCodeBuy"
            ></currency-list-select>
          </v-flex>
          <v-flex xs12 sm3>
            <v-text-field
              label="Sell"
              v-model.number="price.adultSell1"
              type="number"
            ></v-text-field>
          </v-flex>
          <v-flex xs12 sm3>
            <currency-list-select
              customLabel="Currency Sell"
              :currency-code="price.currencyCodeSell"
              v-model="price.currencyCodeSell"
            ></currency-list-select>
          </v-flex>
          <v-flex xs12 sm3>
            <rate-type-list-select
              :rate-type-code="price.rateTypeCode"
              v-model="price.rateTypeCode"
              hideNotInUse
            ></rate-type-list-select>
          </v-flex>
          <v-flex xs12 sm3>
            <v-text-field
              label="Rate Plan"
              v-model="price.ratePlan"
            ></v-text-field>
          </v-flex>
        </v-layout>
      </v-container>
    </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn color="primary" @click="$emit('onCancel')">Cancel</v-btn>
      <v-btn color="primary" @click="$emit('onSave', price)">Save</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import CurrencyListSelect from "../../../shared/CurrencyListSelect";
import RateTypeListSelect from "../../../shared/RateTypeListSelect";
import DatePicker from "../../../shared/DatePicker";
export default {
  name: "service-price-list-item-form",
  props: {
    price: {
      type: Object,
    },
  },
  components: {
    CurrencyListSelect,
    RateTypeListSelect,
    DatePicker,
  },
  data() {
    return {
      formTitle: "Price Edit",
    };
  },
  methods: {
    onDateFromSelected(date) {
      this.price.dateFrom = date;
    },
    onDateToSelected(date) {
      this.price.dateTo = date;
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/gt/suppliers/services/prices/ServicePriceListItemForm.vue